import { alpha, Card, CardActions, CardContent, Container, Typography } from "@mui/material";
import { ButtonResetFilter } from "components/buttons/ButtonResetFilter";
import { MprcFilterEmptyDataset } from "components/filter/MprcFilterEmptyDataset";
import { useMprcTheme } from "components/MprcThemeProvider";
import { resolveMprcMargin } from "components/styles/resolvers";
import * as React from "react";

interface IProps {
    filtered: boolean;
    message: React.ReactNode;
    marginTop?: MprcMargin;
    emptyDatasetMessage?: React.ReactNode;
    resetFilterText?: string;
    onResetFilter?: () => void;
}

export const MprcFilterNoRecords: React.FC<IProps> = (
    { filtered = false, marginTop = "none", message, emptyDatasetMessage, resetFilterText, onResetFilter }
) => {
    const { theme } = useMprcTheme();
    const lNoRecordsMessage = message ?? theme?.MprcFilterNoRecords?.noRecordsMessage;
    const lResetText = resetFilterText ?? theme?.MprcFilterNoRecords?.resetFilterText;

    return filtered
        ? (
            <Container maxWidth="sm" sx={theme => ({ marginTop: resolveMprcMargin(theme, marginTop) })}>
                <Card sx={{ background: (theme) => alpha(theme.palette.warning.light, 0.5) }}>
                    <CardContent sx={{ textAlign: "center" }}>
                        <Typography variant="h4" color="warning.dark">
                            {lNoRecordsMessage}
                        </Typography>
                    </CardContent>
                    {onResetFilter
                        ? (
                            <CardActions sx={{ justifyContent: "center" }}>
                                <ButtonResetFilter color="warning" variant="contained" text={lResetText} onClick={onResetFilter} />
                            </CardActions>
                        )
                        : <CardActions sx={{ p: 0 }} />
                    }
                </Card >
            </Container>
        )
        : <MprcFilterEmptyDataset marginTop={marginTop} message={emptyDatasetMessage ?? lNoRecordsMessage} />;
};
